/* @refresh reload */
import { render } from "solid-js/web";
import "./index.css";

import App from "./App";
import { AppProvider } from "./stores/app";
import { ScenarioProvider } from "./stores/scenario";

if (import.meta.env.DEV) {
  import("solid-devtools")
}

// Check for and recover from corrupted localStorage
try {
  // Allow forcing a clear via URL parameter: ?clearStorage=1
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('clearStorage') === '1') {
    localStorage.clear();
    // Remove the parameter and reload
    urlParams.delete('clearStorage');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.location.replace(newUrl);
  }
  
  const storageKey = "simulering-project";
  const stored = localStorage.getItem(storageKey);
  if (stored) {
    // Try to parse to verify it's valid JSON
    JSON.parse(stored);
  }
} catch (e) {
  console.error("Detected corrupted localStorage, clearing...", e);
  try {
    localStorage.clear();
    // Reload to start fresh
    window.location.reload();
  } catch (clearError) {
    console.error("Failed to clear localStorage:", clearError);
  }
}

const root = document.getElementById("root")

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
    throw new Error(
        "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?"
    )
}

// Note: PostHog initialization is handled by CookieConsent component after user consent

render(() => (
  <ScenarioProvider>
    <AppProvider>
      <App />
    </AppProvider>
  </ScenarioProvider>
), root!)
